import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { PaisComponent } from './pages/pais/pais.component';
import { ProductComponent } from './pages/product/product.component';
import { CategoryComponent } from './pages/category/category.component';
import { CartComponent } from './pages/cart/cart.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { LogUserComponent } from './pages/adminUser/logUser/logUser.component';
import { EditPerfilComponent } from './pages/adminUser/editPerfil/editPerfil.component';
import { MyShoppingComponent } from './pages/adminUser/myShopping/myShopping.component';
import { MyShoppingListComponent } from './pages/adminUser/myShoppingList/myShoppingList.component';
import { NotFoundComponent } from './pages/menssage/notFound/notFound.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'pais/:id', component: PaisComponent},
  { path: 'ingresar', component: LogUserComponent},
  { path: 'perfil', component: EditPerfilComponent},
  { path: 'mis-compras', component: MyShoppingListComponent},
  { path: 'mis-compras/:id', component: MyShoppingComponent},
  { path: 'carrito', component: CartComponent},
  { path: 'pago', component: PaymentComponent},
  { path: 'categoria/:id', component: CategoryComponent},
  { path: 'detalle/:id', component: ProductComponent},
  { path: '404', component: NotFoundComponent},
  { path: '**', redirectTo: '404' }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.routing.ts